import request from "@/utils/request"


export const getBaseByUser = async (userid) => {
  let res = await request.get('/base', { params: { userid: userid } })
  return res
}


